import { jsx as o } from "react/jsx-runtime";
const e = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m5.7 5.7 12.6 12.6M3 12a9 9 0 1 0 18.001 0A9 9 0 0 0 3 12"
      }
    )
  }
);
export {
  e as default
};
